import RecapProductListCategory from 'components/Content/Recap/RecapProductListCategory/RecapProductListCategory';

export default RecapProductListCategory;
